var map = {
	"./Dry Ice Boxes.png": 3624,
	"./FRP Insulated Box.png": 5276,
	"./Insulated Box.png": 3292,
	"./Vaccine Boxes.png": 8405,
	"./services": 8081,
	"./services.json": 8081
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9756;